<!-- src/app/pages/about/about.component.html -->
<section class="about-page">

  <!-- HERO -->
  <div class="about-hero">
    <img
      class="about-hero__img"
      src="../../assets/lydia-christensen.jpg"
      alt="Lydia Christensen"
      loading="eager"
      fetchpriority="high"
    />
    <div class="about-hero__overlay">
      <div class="about-hero__content">
        <div class="about-hero__badge">Libertarian Candidate for U.S. Senate</div>
        <h1>Michigan's Unchained Voice</h1>
        <p class="about-hero__sub">
          She stands in this fight so that the horrors of the past never become
          the reality of the future. For every Michigander. For everyone.
        </p>
      </div>
    </div>
  </div>

  <!-- MAIN CONTENT -->
  <div class="about-body">
    <div class="container">

      <!-- INTRO STATEMENT -->
      <div class="about-lead">
        <p>
          Lydia Christensen is an American politician from Michigan and a candidate
          for the United States Senate in 2026.
        </p>
        <p>
          Michigan deserves a Senator who belongs to the people.
          Meet <span>Lydia Christensen</span> - built from the ground up,
          answering to no political machine, no donor, and no boss.
        </p>
      </div>

      <!-- LYDIA PHOTO GALLERY 
      <div class="about-gallery">
        <div class="about-gallery__header">
          <h2>Meet Lydia</h2>
          <p>A few moments from Lydia's life beyond the campaign.</p>
        </div>

        <div class="about-gallery__grid">

          <div class="about-gallery__item">
            <img
              src="../../assets/lydia-christensen-gothic.jpg"
              alt="Lydia Christensen"
              loading="lazy"
            />
          </div>

          <div class="about-gallery__item">
            <img
              src="../../assets/lydia-christensen-nicer.jpg"
              alt="Lydia Christensen"
              loading="lazy"
            />
          </div>

          <div class="about-gallery__item">
            <img
              src="../../assets/lydia-christensen-puppy.jpg"
              alt="Lydia Christensen with her dog"
              loading="lazy"
            />
          </div>

        </div>
      </div>
-->
      <!-- TWO COLUMN: STORY + STATS -->
      <div class="about-split">
        <div class="about-story">
          <h2>Lydia Christensen's Story</h2> 
          <p> Lydia Christensen's family comes from Ironwood, Michigan, in the heart of the Upper Peninsula. 
            She was born across the border in Ashland, Wisconsin, helicoptered there because the UP lacked 
            the hospital infrastructure to deliver her safely. Growing up connected to Michigan's Upper Peninsula 
            shaped her understanding of hard work, resilience, independence, and community. </p> 
            <p> She didn't have an easy start. Growing up in the foster care system, Lydia built her foundation from 
              scratch, earning the equivalent of two degrees in computer science and computer programming before 
              eventually founding her own technology company. Her background in technology and entrepreneurship taught 
              her how to build something from the ground up, a perspective she now brings to her campaign for the United States Senate. </p> 
            <p> Returning to Michigan after college, she found her purpose in the Upper Peninsula's untamed landscapes — its waterfalls,
               forests, and Great Lakes — and in the people who call Michigan home. Protecting those places became an important part of 
               her work, including her opposition to continued operation of Line 5 through the Straits of Mackinac and her focus on 
               protecting the Great Lakes from environmental harm. </p> <p> As the Libertarian Party nominee for U.S. Senate in Michigan, 
                Lydia's campaign focuses on issues that affect communities across the state, including Great Lakes protection, housing, 
                tribal sovereignty, civil liberties, and economic opportunity. Her approach comes from the same principle that shaped her life:
                 problems should be confronted directly, and solutions should be built from the ground up. </p>
                    <p> Her vision is straightforward: a Michigan where every resident has a voice that is actually heard. 
                      Where the Great Lakes are protected. Where opportunity is not reserved for the well-connected. And where 
                      the lessons of history are never forgotten. Standing in fields of remembrance has shaped her most fundamental
                       belief: that the greatest failure of leadership is letting history repeat itself. </p>
        </div>

        <div class="about-facts">
          <div class="fact-card">
            <div class="fact-card__icon">🏡</div>
            <div class="fact-card__label">Home</div>
            <div class="fact-card__value">Ironwood, MI</div>
          </div>

          <div class="fact-card">
            <div class="fact-card__icon">💻</div>
            <div class="fact-card__label">Background</div>
            <div class="fact-card__value">Computer Science &amp; Founder</div>
          </div>

          <div class="fact-card">
            <div class="fact-card__icon">🗳</div>
            <div class="fact-card__label">Running as</div>
            <div class="fact-card__value">Libertarian Party Nominee</div>
          </div>

          <div class="fact-card">
            <div class="fact-card__icon">🏛</div>
            <div class="fact-card__label">Office sought</div>
            <div class="fact-card__value">U.S. Senate, Michigan</div>
          </div>

          <div class="fact-card">
            <div class="fact-card__icon">📅</div>
            <div class="fact-card__label">Election</div>
            <div class="fact-card__value">November 2026</div>
          </div>

          <div class="fact-card">
            <div class="fact-card__icon">💰</div>
            <div class="fact-card__label">Campaign launched with</div>
            <div class="fact-card__value">Under $1,000 - No PACs</div>
          </div>
        </div>
      </div>

      <!-- WHAT LYDIA STANDS FOR -->
      <div class="about-platform">
        <h2>What Lydia Stands For</h2>

        <div class="platform-grid">

          <div class="platform-card">
            <div class="platform-card__icon">🌊</div>
            <div class="platform-card__title">Environment</div>
            <div class="platform-card__body">
              Protecting Michigan's Great Lakes, clean water, and natural
              landscapes for generations to come.
            </div>
          </div>

          <div class="platform-card">
            <div class="platform-card__icon">🏥</div>
            <div class="platform-card__title">Healthcare</div>
            <div class="platform-card__body">
              Ensuring affordable, comprehensive healthcare for every
              Michigander, including Medicaid for All.
            </div>
          </div>

          <div class="platform-card">
            <div class="platform-card__icon">💼</div>
            <div class="platform-card__title">Economy</div>
            <div class="platform-card__body">
              Creating real economic opportunity with fair wages, green
              jobs, and support for small businesses.
            </div>
          </div>

          <div class="platform-card">
            <div class="platform-card__icon">⚖️</div>
            <div class="platform-card__title">Equity</div>
            <div class="platform-card__body">
              Fighting for social, racial, and LGBTQIA+ equity in every
              community across Michigan.
            </div>
          </div>

          <div class="platform-card">
            <div class="platform-card__icon">🗽</div>
            <div class="platform-card__title">Civil Liberties</div>
            <div class="platform-card__body">
              Upholding voting rights, constitutional freedoms, and
              defending every Michigander's civil liberties.
            </div>
          </div>

          <div class="platform-card">
            <div class="platform-card__icon">🔗</div>
            <div class="platform-card__title">Independence</div>
            <div class="platform-card__body">
              Not beholden to party bosses or corporate donors.
              Answering only to the people of Michigan.
            </div>
          </div>

        </div>
      </div>

      <!-- CAMPAIGN POSTER -->
      <div class="about-mission">
        <iframe
          src="assets/FullsizePoliticalPoster.pdf"
          class="about-poster__embed"
          title="Lydia Christensen for U.S. Senate — Official Campaign Poster">
        </iframe>

        <a href="assets/FullsizePoliticalPoster.pdf" download class="btn-poster-download">
          Download &amp; Print Poster
        </a>

        <blockquote>
          "Michigan deserves a Senator who belongs to the people.
          Lydia intends to be exactly that."
        </blockquote>

        <cite>Lydia Christensen, Libertarian for U.S. Senate, Michigan 2026</cite>
      </div>

      <!-- CTA STRIP -->
      <div class="about-cta-strip">
        <div class="about-cta-strip__text">
          <h3>Ready to Unchain Michigan?</h3>
          <p>
            Join the movement. Every door knocked, every dollar, and every volunteer gets us closer.
          </p>
        </div>

        <div class="about-cta-strip__buttons">
          <a routerLink="/volunteer" class="btn-primary">Become a Captain</a>
          <a routerLink="/donate" class="btn-secondary">Donate Now</a>
        </div>
      </div>

    </div>
  </div>
</section>

